export function hasContent(value) {
  if (typeof value === 'string') return value.trim().length > 0;
  if (Array.isArray(value)) return value.some(hasContent);
  if (!value) return false;
  if (value._type === 'block') return hasContent(value.children);
  if (value._type === 'span') return hasContent(value.text);
  return true;
}

export function trimTrailingBlankBlocks(blocks = []) {
  if (!Array.isArray(blocks)) return [];
  let end = blocks.length;
  while (
    end > 0 &&
    blocks[end - 1]._type === 'block' &&
    !hasContent(blocks[end - 1])
  )
    end -= 1;
  return blocks.slice(0, end);
}
